import type { TEssentialCreditStatus } from 'entities/essentialCreditStatus';

type GetShouldShowEsiaConsentBannerParams = {
  isError: boolean;
  isSuccess: boolean;
  data?: TEssentialCreditStatus;
};

export const getShouldShowEsiaConsentBanner = ({
  isError,
  isSuccess,
  data,
}: GetShouldShowEsiaConsentBannerParams): boolean => {
  if (isError || !isSuccess || !data) {
    return false;
  }

  return data.esiaAuthorized && !data.digitalProfileConsent;
};
